<template lang="html">
  <div class="animal--list">
    <div class="row mainrow">
      <div class="col-12 col-sm-6 maincol" v-for="(animal,i) in animals" :key="i">

            <div class="row" @click="goTo(animal.id)">
              <div class="col-12">
                <div class="animalavatar">
                  <v-img max-height=200 min-width="50%" :src="animal.thumbnailImage">
                    <div v-if="animal.colorcode">
                      <v-icon v-if="animal.colorcode==='green'" :color="animal.colorcode" large>mdi-check-circle</v-icon>
                      <v-icon v-else-if="animal.colorcode==='black'" :color="animal.colorcode" large>mdi-circle</v-icon>
                      <v-icon v-else :color="animal.colorcode" large>mdi-alert</v-icon>
                    </div>
                  </v-img>
                </div>
              </div>
            </div>

            <div class="row" @click="goTo(animal.id)">
              <div class="col-12">
                <div class="animalname">
                  <h3>{{animal.name}}</h3>
                </div>
                <div class="animalinfo">
                  <p>Kora: {{animal.age}}</p>
                  <p>Ivara: {{animal.gender}}</p>

                  <v-btn class="primary">Tovább {{animal.name}} oldalára!</v-btn>
                </div>
              </div>
            </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['animals'],
  computed:{
  },
  methods:{
    goTo(id){
      this.$router.push('/animal/'+ id);
    },
  },
  created(){
    window.scrollTo(0,0);
  }
}
</script>

<style lang="scss" scoped>
.mainrow{
  justify-content: center;
  padding: 0px 0 50px 0;

}
.maincol{
  max-height: 400px;
  max-width: 400px;
}
.v-image{
  border-radius: 5%;
}
.animalinfo,
.animalname{
    text-align: center;
    p{
      margin-bottom: 0;
    }
}

.animalname{
  margin-top: -10px;
}

.animal--list .v-icon{
  position: absolute;
  left: 8px;
  top: 12px;
  z-index: 20;
}
</style>
